import { type CampaignBanner } from '@hooks-api/types/dataModel/campaigns'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Image } from '@pets-ui/Image/Image'
import { Link } from '@pets-ui/Link/Link'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import * as stylex from '@stylexjs/stylex'
import { useMemo } from 'react'

const styles = stylex.create({
  link: {
    width: '100%',
  },
})

interface CategoryPromotionImagesProps {
  campaignBanners?: CampaignBanner[]
  /** 另開新分頁瀏覽image url */
  onClickRedirect?: () => void
}

export const CategoryPromotionImages = (props: CategoryPromotionImagesProps) => {
  const { campaignBanners, onClickRedirect } = props
  const isMobile = useResponsive('mobile')
  const bannerImages = useMemo(() => campaignBanners?.filter(banner => banner.type === 'banner'), [campaignBanners])

  if (!bannerImages?.length) return null

  return (
    <HStack flexWrap="nowrap" gap={3}>
      {bannerImages?.flatMap(bannerImage => bannerImage.images.map((image) => {
        if (isMobile && image.device_type === 'pc') return null
        if (!isMobile && image.device_type === 'mobile') return null
        if (image.url) {
          const imageElement = (
            <Image
              src={image.url}
              width="100%"
              fallback={<Skeleton width="100%" height="188px" />}
              alt={bannerImage.title}
            />
          )
          return (
            <Box key={image.image_id} width="100%">
              {image.link_url
                ? (
                  <Link href={image.link_url} target="_blank" rel="noreferrer" rootStyle={styles.link} onClick={onClickRedirect}>
                    {imageElement}
                  </Link>
                )
                : (
                  imageElement
                )}
            </Box>
          )
        }
        return null
      }))}
    </HStack>
  )
}
